module.exports = "table{width:100%;margin-bottom:20px}.action-bar{margin-top:20px;text-align:right}mat-spinner{margin:auto}.clickable{cursor:pointer}\n"